// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"126354bd","196":"ca7c375a","282":"fddf3f00","497":"ea8144cc","601":"835fcffa"}[chunkId] + ".chunk.js";
};